import { render } from "./ProjectProcureForm.vue?vue&type=template&id=0171b653&scoped=true&ts=true"
import script from "./ProjectProcureForm.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureForm.ts?vue&type=script&lang=ts"

import "./ProjectProcureForm.scss?vue&type=style&index=0&id=0171b653&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0171b653"]])

export default __exports__